// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__NRBTR","title":"Info_title__25lOH","links":"Info_links__tsrmI","link":"Info_link__3gHal","logo":"Info_logo__2MoSe"};